import { Text, Title, Section as BaseSection } from '../../utils/theme';
import styled, { keyframes } from 'styled-components';


export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  box-shadow: 0 0 5vw 5vw #090C1B inset;
  overflow: hidden;
`;

export const ScheduleContainer = styled.div`
  padding: 0vw 5vw;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 600px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const ScheduleColumn = styled.div`
  padding: 1vw 5vw;
  width: 42vw;
  position: relative;
  display: flex; 
  flex-direction: column;

  @media (max-width: 600px) {
    width: 80vw;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const RowItem = styled.div`
  font-size: 1.8vw;
  width: 50%;
  padding-top: 1vw;

  @media (max-width: 600px) {
    font-size: 3.5vw;
  }
`;


export const SubTitle = styled(Text)`
  text-align: left;
  margin: 0 auto;
  font-size: 2vw;
  font-weight: bold;
  width: 100%;

  @media (max-width: 600px) {
    font-size: 5.25vw;
  }
`;

export const ScheduleTitle = styled(Title)`
  text-align: center;
  margin: 0 auto;
  font-size: 4vw;

  @media (max-width: 600px) {
    font-size: 7.25vw;
  }
`;

export const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(1.1);
  }
`;

export const BackgroundImage = styled.img`
  z-index: -1;
  position: absolute;
  top: -20vw;
  width: 100vw;
  min-height: 60vw;
  
  animation: ${pulsing} 20s infinite ease-in-out;

  @media (max-width: 600px) {
    top: 20vw;
    min-height: 80vw;
  }
`;


